import { useEffect, useRef } from "react";
import { useU2000WebSocketContext } from "../../../u2000Core/context/websocket/U2000WebSocketContext";
import {
  isNotificationMessage,
  U3141_LAND_REGISTER_EXCEL_EXPORT_JOB_TYPE,
} from "../../../u2000Core/types/U2000WebSocketMessages";

/**
 * Écoute les notifications WebSocket "notification:new" pour le job U3141 export Excel liste.
 * Lorsque metadata.jobType === U3141_LAND_REGISTER_EXCEL_EXPORT, appelle onRefresh pour
 * rafraîchir la liste des registres fonciers.
 */
export function useU3141LandRegisterListNotification(onRefresh: () => void) {
  const { on, off } = useU2000WebSocketContext();
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    const handleNotification = (message: unknown) => {
      if (!isNotificationMessage(message)) return;

      const metadata = message.metadata as Record<string, unknown> | undefined;
      const jobType = metadata?.jobType as string | undefined;

      if (jobType === U3141_LAND_REGISTER_EXCEL_EXPORT_JOB_TYPE) {
        if (import.meta.env.DEV) {
          console.log("[U3141 Land Register List] Notification export Excel reçue, refresh liste");
        }
        onRefreshRef.current();
      }
    };

    on("notification:new", handleNotification);
    return () => off("notification:new", handleNotification);
  }, [on, off]);
}
